import { useEffect, useState } from "react";
import currencies from "../../Utils/currencies.json";
import { useQueryClient } from "@tanstack/react-query";
import { useCountryStore } from "@/Store/CountryStore";
import countriesData from "../../Utils/countriesAdvanceData.json";
import { FormControl, MenuItem, Select } from "@mui/material";
import { getCurrencySymbol } from "@/helpers/getCurrency";

export function CurrencySelector() {
  const [currency, setCurrency] = useState<string>(
    localStorage.getItem("currency"),
  );
  const [drawerOpen, setDrawerOpen] = useState(false);

  const { ipCountry } = useCountryStore();
  const queryClient = useQueryClient();
  const isMobile = window.innerWidth < 1024;
  // console.log(currencies)
  useEffect(() => {
    if (ipCountry && !currency) {
      const country = countriesData?.find((item) => item.iso3 === ipCountry);

      if (country) {
        localStorage.setItem("currency", country.currency);
        setCurrency(country.currency);
        queryClient.invalidateQueries({
          predicate: (query) => {
            const key = query.queryKey[0];
            return (
              key === "StoreMain" ||
              key === "HomePageMain" ||
              key === "Product" ||
              key === "ProductRecommendation" ||
              key === "search-products" ||
              key === "UpdateCurrencyCart" ||
              key === "CartCalculations"
            );
          },
        });
      }
    }
  }, [ipCountry]);

  const handleChange = (value: string) => {
    setCurrency(value);
    localStorage.setItem("currency", value);

    queryClient.invalidateQueries({
      predicate: (query) => {
        const key = query.queryKey[0];
        return (
          key === "StoreMain" ||
          key === "HomePageMain" ||
          key === "Product" ||
          key === "ProductRecommendation" ||
          key === "search-products" ||
          key === "UpdateCurrencyCart" ||
          key === "CartCalculations"
        );
      },
    });
  };

  return (
    <FormControl
      variant="standard"
      sx={{
        "& .MuiInput-underline:before": { borderBottom: "none" },
        "& .MuiInput-underline:after": { borderBottom: "none" },
        "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
          borderBottom: "none",
        },
      }}
    >
      <Select
        value={currency}
        onChange={(e) => handleChange(e.target.value)}
        displayEmpty
        sx={{
          fontSize: "2vw",
          fontWeight:"600",
          borderBottom: "0",
          "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            gap: "6px",
          },
          "@media (min-width: 1024px)": {
            fontSize: "0.75rem",
          },
        }}
      >
        <MenuItem value="" disabled >
          Select currency
        </MenuItem>
        {currencies.map((c) => (
          <MenuItem className={"!font-[600]"} key={c.code} value={c.code}>
            {getCurrencySymbol(c.code)} {c.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
